import target from './target';
import items from './items';
import assign from './assign';
import assignBySchool from './assignBySchool';
import enter from './enter';
import subresult from './subresult';
import tagresult from './tagresult';
import statresult from './statresult';
import myenter from './myenter';
import myenterView from './myenterView';
import audit from './audit';
import majorSort from './major-sort';
import swot from './swot';
import org from './org';
import earlywarning from './earlywarning';
import assignview from './assignview';
import subresultall from './subresultall';
import mysubenter from './mysubenter';
import auditresult from './auditresult';
import publish from './publish';
import publishResult from './publishResult';
import classAuth from './classAuth';
import groupClassAuth from './groupClassAuth';
import notification from './notification';
import auditresultbyorg from './auditresultbyorg';
import auditresultbyschool from './auditresultbyschool';
import subenterall from './subenterall';
import leadin from './leadin';
import fillingRate from './fillingRate';
import fillingRateView from './fillingRateView';
import collect from './collect';
import collect2 from './collect2';
import teacherPublish from './teacherPublish';
import subresultallByPublish from './subresultallByPublish';

export default {
    target,
    items,
    assign,
    assignBySchool,
    enter,
    subresult,
    tagresult,
    statresult,
    myenter,
    myenterView,
    audit,
    swot,
    majorSort,
    org,
    earlywarning,
    assignview,
    subresultall,
    mysubenter,
    auditresult,
    publish,
    publishResult,
    classAuth,
    groupClassAuth,
	notification,
    auditresultbyorg,
    auditresultbyschool,
    subenterall,
    leadin,
    fillingRate,
    fillingRateView,
    collect,
    collect2,
    teacherPublish,
    subresultallByPublish
}